import { render, staticRenderFns } from "./CheckInfo.vue?vue&type=template&id=2c50b424&scoped=true&"
import script from "./CheckInfo.vue?vue&type=script&lang=js&"
export * from "./CheckInfo.vue?vue&type=script&lang=js&"
import style0 from "./CheckInfo.vue?vue&type=style&index=0&id=2c50b424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50b424",
  null
  
)

export default component.exports